'use client';

import { Archive } from 'lucide-react';

export default function VaultPage() {
  return (
    <div className="space-y-6 max-w-5xl">
      <h1 className="text-xl font-semibold text-white">Vault</h1>
      <p className="text-sm text-gray-500">Saved templates and reusable content blocks</p>
      <div className="text-center py-20 rounded-xl border border-dashed border-white/[0.08]">
        <Archive className="w-10 h-10 mx-auto text-gray-700 mb-3" />
        <p className="text-gray-500 text-sm">No saved templates yet</p>
        <p className="text-xs text-gray-600 mt-1">Save post templates from the Create page to reuse them here</p>
      </div>
    </div>
  );
}
